import { useFilter } from '../contexts/FilterContext';
import { Page } from '../components/ui';
import {
  OverviewHeroSection,
  OverviewMapSection,
  OverviewAssetsSection,
  OverviewTrendChart,
  OverviewPropertyExplorerSection,
  useOverviewKpis,
  useOverviewTrendChart,
} from '../features/overview';
import '../css/overview.css';
import '../css/pieChart.css';
import '../css/simpleLineChart.css';

export const Overview = () => {
  const { selectedClient, periodMode } = useFilter();
  const kpis = useOverviewKpis(periodMode);
  const chart = useOverviewTrendChart(periodMode);

  return (
    <Page className="overview-page">
      <div className="overview-layout">
        <OverviewHeroSection
          clientName={selectedClient?.name || 'User'}
          portfolioValue={kpis.portfolioValue}
          netAnnualRentYield={kpis.netAnnualRentYield}
          ttmRoi={kpis.ttmRoi}
          undistributedEarnings={kpis.undistributedEarnings}
          netEquity={kpis.netEquity}
          ttmCashReceived={kpis.ttmCashReceived}
          portfolioCoc={kpis.portfolioCoc}
          portfolioNoiYield={kpis.portfolioNoiYield}
          capitalAtRisk={kpis.capitalAtRisk}
          capitalAtRiskFootnote={kpis.capitalAtRiskFootnote}
          portfolioSummaryTags={kpis.portfolioSummaryTags}
          loading={kpis.loading}
        />

        <div className="overview-footprint-row">
          <OverviewMapSection locations={kpis.mapLocations} />
          <OverviewAssetsSection composition={kpis.composition} loading={kpis.loading} />
        </div>

        <OverviewTrendChart
          selectedChart={chart.selectedChart}
          viewBy={chart.viewBy}
          yearRange={chart.yearRange}
          availableYears={chart.availableYears}
          series={chart.series}
          loading={chart.loading}
          unitCurrency={chart.unitCurrency}
          periodMode={periodMode}
          dateAnchorKey={kpis.periodAnchorKey}
          onViewByChange={chart.setViewBy}
          onYearRangeChange={chart.setYearRange}
          onChartTypeChange={(id) => chart.selectChart(id)}
        />

        <OverviewPropertyExplorerSection
          overviewData={kpis.overviewData}
          allUnits={kpis.allUnits}
          periodMode={periodMode}
        />
      </div>
    </Page>
  );
};
